export default "__VITE_ASSET__C$RYsxin__"